const customEvents = [
	{
		text: '', key: 'text.customEventLabels.run', value: 0, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.walk', value: 1, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.nordicWalking', value: 2, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.mixedWalking', value: 3, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.hiking', value: 4, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.inlineSkating', value: 5, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.wheelChair', value: 6, measurement: 'm',
	},
	{
		text: '', key: 'text.customEventLabels.timeRun', value: 7, measurement: 'h',
	},
	{
		text: '', key: 'text.customEventLabels.else', value: 8, measurement: 'm',
	},
];

function getCustomEvents(_this) {
	customEvents.forEach((x) => {
		if (x.key != null) x.text = _this.$t(x.key);
	});
	return customEvents;
}

export default getCustomEvents;
